import { useCallback, useEffect, useRef } from "react";

import type {
  PendingCellValue,
  PendingCellValueRef,
} from "./withPendingValueGetter";

interface UsePendingCellValueResult {
  pendingRef: PendingCellValueRef;
  setPendingCellValue: (rowId: string, colId: string, value: unknown) => void;
}

export const usePendingCellValue = <TPayload>(
  payload: TPayload,
): UsePendingCellValueResult => {
  const pendingRef = useRef<PendingCellValue>(null);

  useEffect(() => {
    pendingRef.current = null;
  }, [payload]);

  const setPendingCellValue = useCallback(
    (rowId: string, colId: string, value: unknown): void => {
      pendingRef.current = { rowId, colId, value };
    },
    [],
  );

  return { pendingRef, setPendingCellValue };
};
